import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { ConfigService } from '../../services/config/config.service';
import { ActivatedRoute } from '@angular/router';
import { NoteService } from '../../services/note/note.service';
import { ValidationService } from '../../services/validation/validation.service';

@Component({
	selector: 'pcm-user-accept',
	templateUrl: './user-accept.component.html',
	styleUrls: ['./user-accept.component.scss']
})

export class UserAcceptComponent implements OnInit {

	passwordMinimumLength = 15;

	data = {
		password: '',
		passwordConfirm: '',
		email: '',
		acceptToken: ''
	};

	constructor(
		public userService: UserService,
		private configService: ConfigService,
		public noteService: NoteService,
		private route: ActivatedRoute,
		public validationService: ValidationService
	) { }

	ngOnInit() {
		const self = this;
		this.userService.removeAuth();
		self.route.params.subscribe(params => {
			self.data.acceptToken = params['acceptToken'];
			self.userService.setPersona('anon');
			self.userService.setToken(self.data.acceptToken);
			console.log('USER ACCEPT PARAMS', self.data);
		});

		this.configService.fieldsConfigLoadedSubject.subscribe(undefined, undefined, () => {
			this.userService.acceptDataConfig = this.configService.getDataObj(this.userService.acceptDataObj);
		});
	}

	pageFormSubmit() {
		console.log('PAGE FORM SUBMIT', this.data);
		this.userService.sendPassword(this.data);
	}
	
	onCloseNote() {
		this.noteService.currentNote.active = false;
	}

}
